import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { moment } from "@msuite/utils/date";
import { guardString } from "@msuite/utils/strings";
import { UserCard } from "@/components/cards";
import {
	formatInvoiceAmount,
	IncomingInvoiceApprovalStateTag,
} from "@/components/incoming-invoices";
import type { DecisionRow } from "./decision-row";

const columnHelper = createColumnHelper<DecisionRow>();

export const columns = [
	columnHelper.accessor("createdAt", {
		id: "createdAt",
		header: localized("incoming_invoices.decided_at"),
		cell: (cell) => moment(cell.getValue()).longFormat(),
		size: 150,
	}),
	columnHelper.accessor((row) => guardString(row.user?.name), {
		id: "user",
		header: localized("incoming_invoices.approver"),
		cell: (cell) => {
			const user = cell.row.original.user;
			return user ? (
				<UserCard
					userId={user.id}
					variant="plain"
				/>
			) : (
				guardString(null)
			);
		},
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("incoming_invoices.approval_state.state"),
		cell: (cell) => <IncomingInvoiceApprovalStateTag state={cell.getValue()} />,
		size: 130,
	}),
	columnHelper.accessor("reducedNetAmount", {
		id: "reducedNetAmount",
		header: localized("incoming_invoices.decision.reduced_net_amount"),
		cell: (cell) => {
			const amount = cell.getValue();
			return amount === null
				? guardString(null)
				: formatInvoiceAmount(amount, cell.row.original.currency);
		},
	}),
	columnHelper.accessor("reductionReason", {
		id: "reductionReason",
		header: localized("incoming_invoices.decision.reduction_reason"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("comment", {
		id: "comment",
		header: localized("incoming_invoices.approval_comment"),
		cell: (cell) => guardString(cell.getValue()),
	}),
];
